export default class AdminICD10Reports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminICD10ReportsRoute, {
      params
    })
  }

  getChart(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminICD10ReportsRoute}/chart`, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminICD10ReportsRoute}/export`, {
      params,
      responseType: "blob"
    })
  }
}
